var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","color":"blue darken-2","disabled":_vm.toggleDisabled}},[_c('v-icon',{on:{"click":function($event){return _vm.toggleRow()}}},[_vm._v("\n    "+_vm._s(_vm.toggleIcon(_vm.dynalabelItem))+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }